import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { TokenService } from '../../token.service';
import { MainService } from './main.service';
@Injectable({
  providedIn: 'root'
})
export class GratuityService {

  httpUrl;
  constructor(private http: HttpClient, private main: MainService, private token: TokenService) {
    this.httpUrl = this.main.httpUrl;
  }
  // httpUrl2 = this.main.httpUrl


  async getSalaryDetails(obj: any) {
    var resp = await this.http.get<any>(this.httpUrl + "/hr/payroll_info/gratuity/getSalaryDetails" + obj).toPromise();
    return resp;
  }

  async getGratuityList(obj: any) {
    var resp = await this.http.get<any>(this.httpUrl + "/hr/payroll_info/gratuity/getGratuityList" + obj).toPromise();
    return resp;
  }
  async gratuityById(obj: any) {
    var resp = await this.http.get<any>(this.httpUrl + "/hr/payroll_info/gratuity/gratuityById" + obj).toPromise();
    return resp;
  }
  async detailsForSendToAcc(obj: any) {
    var resp = await this.http.get<any>(this.httpUrl + "/hr/payroll_info/gratuity/detailsForSendToAcc" + obj).toPromise();
    return resp;
  }

  async saveGratuity(obj: any) {
    var resp = await this.http.post<any>(this.httpUrl + "/hr/payroll_info/gratuity/saveGratuity", obj).toPromise();
    return resp;
  }
  async updateGratuity(obj: any) {
    var resp = await this.http.post<any>(this.httpUrl + "/hr/payroll_info/gratuity/updateGratuity", obj).toPromise();
    return resp;
  }

  async changeStatus(obj: any) {
    var resp = await this.http.put<any>(this.httpUrl + "/hr/payroll_info/gratuity/changeStatus", obj).toPromise();
    return resp;
  }
  async getNotesheet(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/hr/payroll_info/gratuity/getNotesheet' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }
}
